import { useMemo } from "react";

import { HUMANIZE_PROVIDER } from "constants/vcsProviders";
import useTypedContext from "hooks/useTypedContext";
import KeyValue from "components/KeyValue";
import ValuesList from "components/ValuesList";
import { VcsProvider } from "types/generated";

import { ModuleVcsFormFields } from "../types";
import { ModuleFormContext } from "../context";

type NewModuleSummaryVcsProps = {
  data: ModuleVcsFormFields;
};

const NewModuleSummaryVcs = ({ data }: NewModuleSummaryVcsProps) => {
  const { internalData } = useTypedContext(ModuleFormContext);

  const gitSparseCheckoutPathsValues = useMemo(
    () => data.gitSparseCheckoutPaths?.map((path) => path.value),
    [data.gitSparseCheckoutPaths]
  );

  return (
    <>
      <KeyValue name="Provider">{data.provider && HUMANIZE_PROVIDER[data.provider]}</KeyValue>

      {data.vcsIntegrationId && (
        <KeyValue name="Integration">
          {internalData.vcsIntegrationLabel || data.vcsIntegrationId}
        </KeyValue>
      )}

      {data.repository && data.namespace && data.provider !== VcsProvider.Spacelift && (
        <KeyValue name="Repository">{`${data.namespace}/${data.repository}`}</KeyValue>
      )}
      {data.repository && (!data.namespace || data.provider === VcsProvider.Spacelift) && (
        <KeyValue name="Repository">{data.repository}</KeyValue>
      )}
      {data.provider !== VcsProvider.Spacelift && <KeyValue name="Branch">{data.branch}</KeyValue>}
      {data.repositoryURL && <KeyValue name="Repository URL">{data.repositoryURL}</KeyValue>}
      {data.projectRoot && <KeyValue name="Project root">{data.projectRoot}</KeyValue>}
      <KeyValue name="Git sparse checkout paths">
        {gitSparseCheckoutPathsValues?.length && (
          <ValuesList values={gitSparseCheckoutPathsValues} />
        )}
      </KeyValue>
    </>
  );
};

export default NewModuleSummaryVcs;
